import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;
const apikey = process.env.REACT_APP_API_KEY;

export const cityApi = createApi({
  reducerPath: "cityApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("apiKey", apikey);
      headers.set("Authorization", JSON.parse(localStorage.getItem("loginData")).token);
      return headers;
    },
  }),
  tagTypes: ["City", "cityDetails"],
  endpoints: (builder) => ({
    getCityList: builder.query({
      query: (body) => ({
        url: `/admin/getCityList`,
        method: "POST",
        body,
      }),
      providesTags: ["City"],
    }),

    getCityDetails: builder.query({
      query: (body) => ({
        url: `/admin/getCityDetails`,
        method: "POST",
        body,
      }),
      providesTags: ["cityDetails"],
    }),

    addCity: builder.mutation({
      query: (body) => ({
        url: `/admin/addCity`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["City"],
    }),

    editCity: builder.mutation({
      query: (body) => ({
        url: `/admin/editCity`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["City", "cityDetails"],
    }),

    changeCityStatus: builder.mutation({
      query: (body) => ({
        url: `/admin/changeCityStatus`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["City", "cityDetails"],
    }),

    deleteCity: builder.mutation({
      query: (body) => ({
        url: `/admin/deleteCity`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["City", "cityDetails"],
    }),

    changeSubscriptionRequired: builder.mutation({
      query: (body) => ({
        url: "/admin/changeSubscriptionRequired",
        method: "POST",
        body,
      }),
      invalidatesTags: ["City", "cityDetails"],
    }),
  }),
});

export const {
  useGetCityListQuery,
  useGetCityDetailsQuery,
  useAddCityMutation,
  useEditCityMutation,
  useChangeCityStatusMutation,
  useDeleteCityMutation,
  useChangeSubscriptionRequiredMutation,
} = cityApi;
